// extracted by mini-css-extract-plugin
export default {"container":"header_container__dbRCQ","logo":"header_logo__kAF7m","navDiv":"header_navDiv__VqjQS","notificationDiv":"header_notificationDiv__ap0po"};